import React from 'react';

import thickIcon from 'assets/icons/thick.svg';
import placeholderImage from 'assets/icons/placeholderImage.svg';

interface Props {
  location: {
    ref: string;
    image: string;
    name: string;
    thumbnailImage: string;
  };
  selectedLocationRef: string;
  onClick: () => void;
}

const LocationSwitchListItem: React.FC<Props> = ({
  location,
  selectedLocationRef,
  onClick
}) => {
  const locationImageUrl =
    location.thumbnailImage || location.image || placeholderImage;

  return (
    <div
      className="LocationSwitch colab-clickable"
      key={location.ref}
      onClick={onClick}>
      <div className="LocationSwitch__container colab-row-space-between colab-bold colab-clickable colab-sidepadding-1">
        <div className="colab-centered">
          <img
            className="LocationSwitch__image"
            src={`${locationImageUrl}?w=50&h=50&fit=crop`}
            alt={location.name}
          />
          <div>{location.name}</div>
        </div>
        {selectedLocationRef === location.ref && (
          <div className="colab-centered">
            <img src={thickIcon} alt="Location selected" />
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationSwitchListItem;
